import { normalizeStringToNFD } from "./normalize-string";

export const propContainsString = (prop: any, searchString: string) => {
  const newProp = normalizeStringToNFD(prop);
  const newSearchString = normalizeStringToNFD(searchString);
  return (
    newProp.toString().toLowerCase().indexOf(newSearchString) !== -1 ||
    newProp.toString().indexOf(newSearchString) !== -1
  );
};
